import React, { useState } from "react";
import TextInputField from "../text-input-field/TextInputField";
import BaseButtons from "../base-buttons/BaseButtons";

const SearchBar = ({
  marginTop,
  size,
  width,
  placeholder,
  color,
  fontColor,
  originalSearchArray,
  arrayToSearchInput,
  setResultsArray,
}) => {
  const [searchValue, setSearchValue] = useState("");

  const clearSearch = async () => {
    setSearchValue("");
    setResultsArray(originalSearchArray);
  };

  const performSearch = async () => {
    if (searchValue === "" || searchValue == undefined) {
      setResultsArray(originalSearchArray);
      return;
    }

    if (!Array.isArray(arrayToSearchInput) || arrayToSearchInput.length < 1) {
      return;
    }

    let results = [];

    arrayToSearchInput.map((element) => {
      let valuesArray = Object.values(element);
      let value = JSON.stringify(valuesArray);
      if (value.toLowerCase().includes(searchValue)) results.push(element);
    });

    setResultsArray(results);
  };

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div style={{ width: 10 }} />
      <TextInputField
        width={width}
        size={size ? size : 180}
        height={20}
        marginTop={marginTop ? marginTop : -5}
        mini={true}
        placeholder={placeholder ? placeholder : "Type here to search..."}
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        color={color}
        fontColor={fontColor}
      />
      <div style={{ width: 5 }} />
      <BaseButtons
        label={"SEARCH"}
        // borderRadius={8}
        backgroundColor="#24855B"
        width={80}
        height={35}
        onClick={() => performSearch()}
      />
      {/* <div style={{ width: 5 }} /> */}
      <BaseButtons
        label={"CLEAR"}
        // borderRadius={8}
        backgroundColor="#D86300"
        width={80}
        height={35}
        onClick={() => clearSearch()}
      />
    </div>
  );
};

export default SearchBar;
